var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"main-footer"},[_c('div',{staticClass:"pull-right hidden-xs"},[_vm._v("\n    "+_vm._s(_vm.moment().format('YYYY'))+", "),_c('a',{attrs:{"href":"https://inshopcrm.com","target":"_blank"}},[_vm._v("Inshop CRM, v1.2.3")])]),_vm._v(" "),_vm._v("\n  "+_vm._s(_vm.$t('powered_by'))+" "),_c('a',{attrs:{"href":"https://inshopgroup.com","target":"_blank"}},[_vm._v("Inshop Group")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f587d264","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/FooterSlot.vue
// module id = 894
// module chunks = 0